import { observer } from 'mobx-react'
import React from 'react'

import { getDifferenceInMinutes } from '@flowwai-frontend/bps-officer-web/common/ui'
import { useUserAppConfigStore } from '@flowwai-frontend/bps-officer-web/iam'
import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { getFormatedLastClockInTimeFromDate } from '../../utils/AttendanceUtils'
import { lastClockInSectionClassName } from './styles'

interface Props {
   onClickClockOut: () => void
}

const LastClockInSection = (props: Props): React.ReactElement => {
   const t = useCustomT('navbar:footer')

   const userAppConfigStore = useUserAppConfigStore()
   const { userDetails } = userAppConfigStore

   const getClockInWithDateTime = (clockIn: string): Date => {
      const todayDate = new Date()

      const [hours, minutes, seconds] = clockIn.split(':').map(Number)
      todayDate.setHours(hours, minutes, seconds, 0)

      return todayDate
   }

   const getUserReadableFormat = (formattedLastClockIn: Date): string => {
      const diffInMinutes = getDifferenceInMinutes(
         formattedLastClockIn,
         new Date()
      )
      return getFormatedLastClockInTimeFromDate(diffInMinutes)
   }

   const renderSection = (clockInWithString: string): JSX.Element => {
      const clockInWithDataTime = getClockInWithDateTime(clockInWithString)
      const userReadableDate = getUserReadableFormat(clockInWithDataTime)

      return (
         <div className={lastClockInSectionClassName}>
            <div className='flex flex-col gap-[2px]'>
               <span className='text-xs-regular text-gray-600'>
                  {t('sinceLastClockIn')}
               </span>
               <span className='text-sm-semibold text-gray-700'>
                  {userReadableDate}
               </span>
            </div>
            <Button
               hierarchy={Hierarchy.Primary}
               subVariant={SubVariant.Primary}
               size={'Small'}
               onClick={props.onClickClockOut}
            >
               {t('clockOut')}
            </Button>
         </div>
      )
   }

   if (!userDetails?.attendance?.clockIn) return <></>
   return renderSection(userDetails.attendance.clockIn)
}

export default observer(LastClockInSection)
